import React from 'react'
import EmployeeNavbar from '../../Components/EmployeeNavbar'
import { Outlet, useLocation } from 'react-router-dom'

function ViewEmployee() {

    const location = useLocation();
    const data = location?.state?.data?.allData;

    return (
        <>
                <div className=''>
                    <div >
                        <EmployeeNavbar data={data} />
                    </div>

                    <div className='mt-4'>
                        <Outlet />
                    </div>
                </div>
        </>
    )
}

export default ViewEmployee